import React from 'react';
import { NpcPublicDTO } from '@hexcrawl/shared-utils';
import { AppearancePreview } from '../character/appearance/AppearancePreview';
import { StaticSpritePreview } from '../character/appearance/StaticSpritePreview';

const PORTRAIT_SIZE = 96;

interface Props {
  npc: NpcPublicDTO;
  onBack: () => void;
}

export const NpcDetail: React.FC<Props> = ({ npc, onBack }) => (
  <div style={{ width: 380, fontFamily: 'monospace' }}>
    <button
      onClick={onBack}
      style={{ background: 'none', border: 'none', color: '#888', cursor: 'pointer', fontSize: 12, padding: 0, marginBottom: 12 }}
    >
      ← Back
    </button>

    <div style={{ display: 'flex', gap: 16, alignItems: 'flex-start', marginBottom: 20 }}>
      {npc.spriteType === 'composite' && npc.characterDefinition
        ? <AppearancePreview definition={npc.characterDefinition} size={PORTRAIT_SIZE} />
        : npc.spriteType === 'static' && npc.sprite
          ? <StaticSpritePreview filename={npc.sprite} size={PORTRAIT_SIZE} />
          : <Placeholder size={PORTRAIT_SIZE} />
      }
      <div style={{ paddingTop: 4 }}>
        <div style={{ fontSize: 16, fontWeight: 'bold', color: '#e8e8ff' }}>{npc.name}</div>
        <div style={{ fontSize: 11, color: '#666', marginTop: 2 }}>Level {npc.level}</div>
      </div>
    </div>

    <p style={{ margin: 0, fontSize: 13, color: '#ccc', lineHeight: 1.6, fontStyle: 'italic' }}>
      {npc.playerExposedDescription || 'A mysterious figure whose story is yet to be told.'}
    </p>
  </div>
);


const Placeholder: React.FC<{ size: number }> = ({ size }) => (
  <div style={{
    width: size,
    height: size,
    background: '#0d0d1a',
    border: '1px solid #333',
    borderRadius: 6,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    color: '#444',
    fontSize: 28,
  }}>
    ?
  </div>
);
